import React, { useState, useRef, useEffect } from 'react';

import { Box, Flex, Image, Spinner, Divider, Grid, Text } from "@chakra-ui/react";
import OrgProfileTeamModule from '../../../organizations/components/OrgProfileTeamModule';
import OrgInfoDisplay from '../../../organizations/components/OrgInfoDisplay';
import AddOrgMemberModule from '../../../organizations/components/edit-team/AddOrgMemberModule';
import BrandingGuideColorCard from './BrandingGuideColorCard';
import ProAccountNeededIcon from '../../../global/components/product-marketing/ProAccountNeededIcon';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import SubscriptionNudgeModal from '../../../marketing/components/SubscriptionNudgeModal';


export default function OrgManagementModule({
	getAdminOrgProfile,
	adminOrgProfile,
	manageAdminOrgUsersOutcome,
	updateOrgProfile,
	// updateOrgProfileReset
	// Redux
	paidFeatureAccess
}) {

	const [localState, setLocalState] = useState({
		orgIdToken: "",
		orgName: "",
		orgDescription: "",
		orgRegisteredAddress: "",
		orgRegisteredName: "",
		orgRegisteredNumber: "",
		orgRegisteredCountry: "",
		orgLogo: "",
		orgBranding: "",
		//Upload
		uploadedLogo: "",
		orgSeats: "",
		//UX
		buttonIsLoading: false,
		noOrgFound: "",
		isAdministrator: "",
		logoImageIsLoading: true,
		// Users management
		orgAdminUsers: null,
		orgBasicUsers: null
	})

	const initRef = useRef(false);
	const [showSubscriptionNudge, setShowSubscriptionNudge] = useState(false);

	useEffect(() => {
		if (getAdminOrgProfile && !initRef.current) {
			getAdminOrgProfile();
			initRef.current = true
		}
	}, [getAdminOrgProfile])

	useEffect(() => {
		if (adminOrgProfile) {

			const {
				orgId,
				orgName,
				orgDescription,
				orgRegisteredAddress,
				orgRegisteredName,
				orgRegisteredNumber,
				orgRegisteredCountry,
				isAdministrator,
				orgLogo,
				orgSeats,
				orgAdminUsers,
				orgBasicUsers,
				orgBranding
			} = adminOrgProfile || {};


			setLocalState(prevState => ({
				...prevState,
				isAdministrator,
				orgName,
				orgDescription,
				orgRegisteredAddress,
				orgRegisteredName,
				orgRegisteredNumber,
				orgRegisteredCountry,
				orgLogo,
				orgBranding,
				orgSeats,
				noOrgFound: false,
				logoImageIsLoading: orgLogo ? true : false,
				orgIdToken: orgId,
				// Org Users
				orgAdminUsers,
				orgBasicUsers
			}))
		} else {
			setLocalState(prevState => ({
				...prevState,
				noOrgFound: true
			}));
		}
	}, [adminOrgProfile])

	const preloadImages = () => {
		const { orgLogo } = localState || {};

		const handleLogoImageLoading = () => {
			setLocalState({
				...localState,
				logoImageIsLoading: false
			})
		}

		return (
			<Box className="image-loading__in-progress">
				<Image src={orgLogo} onLoad={() => handleLogoImageLoading()} h='1px' w='1px' />
			</Box>
		)
	}

	useEffect(() => {
		if (manageAdminOrgUsersOutcome) {
			const updateWithNewOutcome = (manageAdminOrgUsersOutcome) => {
				const { updatedSuccessfully, updatedOrgAdminUsers, updatedOrgBasicUsers } = manageAdminOrgUsersOutcome || {};

				if (updatedSuccessfully === true) {
					setLocalState({
						...localState,
						orgAdminUsers: updatedOrgAdminUsers,
						orgBasicUsers: updatedOrgBasicUsers
					})
				}
			}

			updateWithNewOutcome(manageAdminOrgUsersOutcome)
		}
	}, [manageAdminOrgUsersOutcome, localState])


	const {
		noOrgFound,
		isAdministrator,
		orgName,
		orgAdminUsers,
		orgBasicUsers,
		orgIdToken,
		orgBranding
	} = localState;

	const handleSaveOrgBrandColor = (property, value) => {
		const updatedOrgBranding = {
			...orgBranding,
			[property]: value
		}

		setLocalState(prevState => ({
			...prevState,
			orgBranding: updatedOrgBranding
		}))


		updateOrgProfile(updatedOrgBranding, orgIdToken, 'edit-org-branding')

	}

	if (noOrgFound === false && isAdministrator) {
		return (
			<Flex w='100%' direction='column' gap='8em'>
				<OrgInfoDisplay getAdminOrgProfile={getAdminOrgProfile} />

				<Box>
					<Flex alignItems='center' justify='space-between'>
						<Flex justify={['flex-start', 'center', 'center', 'center']} alignItems={['flex-start', 'center', 'center', 'center']} direction={['column', 'row', 'row', 'row']}>
							<Box className="user-profile-section__first-label"> Branding </Box>
						</Flex>

						{!paidFeatureAccess &&
							<LaunchdeckButton bg={'gray.500'} color={'white'} onClick={() => setShowSubscriptionNudge(true)}>
								<Flex align='center' gap={2}>
									Apply colors <ProAccountNeededIcon />
								</Flex>
							</LaunchdeckButton>
						}

					</Flex>
					<Divider my='0.5em' />

					{paidFeatureAccess ?
						<Flex align='flex-start'>
							<Grid w='100%' maxW='900px' templateColumns="1fr 1fr 1fr" gap='2em'>
								<BrandingGuideColorCard orgBranding={orgBranding} displayedColor={orgBranding?.primaryColor} cardTitle="Brand color" cardDescription="Select a color that best represents your brand" handleSaveOrgBrandColor={handleSaveOrgBrandColor} />
								<BrandingGuideColorCard orgBranding={orgBranding} displayedColor={orgBranding?.secondaryColor} cardTitle="Accent color" cardDescription="Select something that elevates your brand color" handleSaveOrgBrandColor={handleSaveOrgBrandColor} />
								<BrandingGuideColorCard orgBranding={orgBranding} displayedColor={orgBranding?.primaryColor} cardTitle="Text color" cardDescription="Select which text color works best with your chosen colors" handleSaveOrgBrandColor={handleSaveOrgBrandColor} />
							</Grid>
						</Flex>
						:
						<Box>
							<Box mt='1.8em'>
								<Text lineHeight='1.375em' fontWeight='400' fontSize='0.8em' color='gray.500' mt='0.5em'>Branding colors not yet provided</Text>
							</Box>
						</Box>
					}
				</Box>

				<Box id="organization-team-edit">
					<Flex alignItems='center' justify='space-between'>
						<Flex justify={['flex-start', 'center', 'center', 'center']} alignItems={['flex-start', 'center', 'center', 'center']} direction={['column', 'row', 'row', 'row']}>
							<Box className="user-profile-section__first-label"> Team </Box>
						</Flex>

						<AddOrgMemberModule orgIdToken={orgIdToken} />
					</Flex>

					<Divider mt='0.5em' />
					<OrgProfileTeamModule
						isAdmin={isAdministrator}
						orgIdToken={orgIdToken}
						orgName={orgName}
						orgAdminUsers={orgAdminUsers}
						orgBasicUsers={orgBasicUsers}
					/>
				</Box>

				{showSubscriptionNudge && <SubscriptionNudgeModal
					titleText="🎨 Apply your own brand colors"
					copyText={`Upgrade & customise your Rooms today!`}
					handleCloseModal={() => setShowSubscriptionNudge(false)} />}
			</Flex>
		)
	}

	if (!noOrgFound) {
		return (
			<Flex w='100%' h='70rem' alignItems='center' justify='center' height='50%' my='3%'>
				<Spinner
					thickness="5px"
					speed="0.65s"
					emptyColor="gray.200"
					color="brand.500"
					boxSize="5em"
				/>

				{preloadImages()}
			</Flex>
		)
	} else return null;
}